// helper for ngAnnotate
window.ngInject = (f) => f;

if (window.angular == null) {
  window.angular = require('angular');
}
